import { jsxs as t, jsx as e } from "react/jsx-runtime";
const r = ({}) => /* @__PURE__ */ t(
  "svg",
  {
    width: "100",
    height: "100",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t("g", { clipPath: "url(#clip0_864_10190)", children: [
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M100 50C100 77.6145 77.6145 100 50 100C22.3855 100 0 77.6145 0 50C0 22.3855 22.3855 0 50 0C77.6145 0 100 22.3855 100 50Z",
            fill: "#E7E7F6"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M63.8698 74.6227C66.8849 74.6227 69.332 72.1705 69.332 69.1491V40.3069C69.332 40.3069 66.622 39.3293 61.8215 42.3333C57.0209 45.3372 56.331 48.3353 50.2143 48.9999C44.0976 49.6646 41.9235 45.9999 37.2807 44.9999C32.6378 43.9999 31.0967 46.9736 31.0967 46.9736V69.1491C31.0967 72.1705 33.5437 74.6227 36.5589 74.6227",
            fill: "var(--plac-icon-fill-active)"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M63.8698 74.6227C66.8849 74.6227 69.332 72.1705 69.332 69.149V36.3069H31.0967V69.149C31.0967 72.1705 33.5437 74.6227 36.5589 74.6227H63.8698Z",
            stroke: "var(--plac-primary-gray)",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ e("path", { d: "M73.4286 30.8333H27", stroke: "var(--plac-primary-gray)", strokeWidth: "2" }),
        /* @__PURE__ */ e("path", { d: "M73.4286 36.3069H27", stroke: "var(--plac-primary-gray)", strokeWidth: "2" }),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M50.2142 59.1492V67.7807",
            stroke: "white",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M42.021 67.7807V53.3596",
            stroke: "white",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M58.4075 67.7807V53.3596",
            stroke: "white",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M42.021 30.8333H58.4076V26.693C58.4076 25.9566 57.8106 25.3596 57.0742 25.3596H43.3543C42.6179 25.3596 42.021 25.9566 42.021 26.693V30.8333Z",
            stroke: "var(--plac-primary-gray)",
            strokeWidth: "2",
            strokeLinejoin: "round"
          }
        )
      ] }),
      /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "clip0_864_10190", children: /* @__PURE__ */ e("rect", { width: "100", height: "100", fill: "white" }) }) })
    ]
  }
);
export {
  r as DeleteIllustration
};
//# sourceMappingURL=index.es485.js.map
